import React from 'react'

// import { CheckDispatchContext } from './checkDispatchContext'

import { WorkOrderCheckInOut } from '../../../interfaces/WorkOrder/WorkOrder'

import { Box, Button, CircularProgress, TextField } from '@mui/material'
import { useUser } from '../../../hooks/useUser'
import { useCheck } from '../context/useCheck'
import { checkBusiness } from '../actions/checkBusiness'
import { checkActions } from '../actions/checkActions'

/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: se módifica DispatcherInputCheckIn por cambio a useReducer + Context
 */

interface DispatcherInputCheckInProps {}

export const DispatcherInputCheckIn: React.FC<
  DispatcherInputCheckInProps
> = () => {
  const {
    userDataState: { userData }
  } = useUser()

  const {
    state: { workOrderSearchCheckInOut, workOrderDispatcher, loading },
    dispatch
  } = useCheck()

  const { setWorkOrderDispatcher } = checkActions()

  const { createCheckin } = checkBusiness()

  let carrierCode: string = ''
  if (workOrderSearchCheckInOut?.workOrderOutbound != null) {
    const { code } = workOrderSearchCheckInOut?.workOrderOutbound.carrier
    carrierCode = code
  }

  const body: WorkOrderCheckInOut = {
    workOrderId: workOrderSearchCheckInOut?.workOrderId!,
    carrierCode: workOrderDispatcher,
    updateCarrier: false,
    userId: userData?.userId!,
    oldcarrierCode: carrierCode
  }

  const handleCreateCheckIn = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    createCheckin(body)
  }

  const isValidCarrierValue: boolean =
    workOrderDispatcher.length <= 0 || loading

  return (
    <Box
      display='flex'
      flexDirection='column'
      gap='10px'
      flexWrap='wrap'
      alignItems='center'
      p={1}
      m={1}
    >
      <form onSubmit={(e) => handleCreateCheckIn(e)}>
        <TextField
          id='standard-multiline-flexible'
          type='text'
          value={workOrderDispatcher}
          onChange={(e) => dispatch(setWorkOrderDispatcher(e.target.value))}
          variant='outlined'
          fullWidth
          autoFocus
          inputProps={{
            autoComplete: false
          }}
        />

        <Button
          variant='contained'
          color='primary'
          type='submit'
          fullWidth
          disabled={isValidCarrierValue}
          startIcon={loading ? <CircularProgress size='0.9rem' /> : undefined}
        >
          {`Registrar ${
            workOrderSearchCheckInOut?.workOrderOutbound === null
              ? 'llegada'
              : 'salida'
          } de Transportista`}
        </Button>
      </form>
    </Box>
  )
}
